const productPhotoInitials = (name?: string): string => {
    const words = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (!words.length) return '';
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return `${words[0][0] || ''}${words[1][0] || ''}`.toUpperCase();
};

export default productPhotoInitials;
